<template>
  <div class="ai-visibility-prompts-step">
    <step-intro
      title="Choose the questions (prompts) to track"
      description="Select questions your customers ask AI. We recommend starting with 5. Add more anytime."
    />
    <question-picker
      :groups="groups"
      :custom-questions="customQuestions"
      :selected-question-ids="selectedQuestionIds"
      :validation-errors="validationErrors"
      custom-display-mode="inline"
      @toggle-question="$emit('toggle-question', $event)"
      @add-custom-question="addCustomQuestion"
      @add-custom-questions="addCustomQuestions"
      @update-custom-question="$emit('update-custom-question', $event)"
      @delete-custom-question="$emit('delete-custom-question', $event)"
    />
  </div>
</template>

<script>
import { normalizeCustomQuestion } from '../../utils'
import QuestionPicker from '../../questions/QuestionPicker.vue'
import StepIntro from '../ui/StepIntro.vue'

export default {
  name: 'PromptsStep',
  components: {
    QuestionPicker,
    StepIntro,
  },
  props: {
    groups: {
      type: Array,
      default: () => [],
    },
    customQuestions: {
      type: Array,
      default: () => [],
    },
    selectedQuestionIds: {
      type: Array,
      default: () => [],
    },
    validationErrors: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    addCustomQuestion (text) {
      this.$emit('add-custom-question', normalizeCustomQuestion(text, this.customQuestions.length))
    },
    addCustomQuestions (questions) {
      this.$emit('add-custom-questions', questions.map((text, index) => (
        normalizeCustomQuestion(text, this.customQuestions.length + index)
      )))
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-prompts-step {
  display: flex;
  min-height: 100%;
  flex-direction: column;
}
</style>
